
import { tns } from 'tiny-slider/src/tiny-slider'


export default () => {

	const els = [...document.querySelectorAll('.carousel__logo')]
	els.map(el => {

		const carouselEl = el.querySelector('.carousel__inner')
		if (!carouselEl) return null

		const carouselNav = el.querySelector('.carousel__nav')


		// remove classes for setting pagewidth before carousel inits
		carouselEl.classList.remove('grid')
		carouselEl.classList.remove('page-width')

		return tns({
			container: carouselEl,
			items: 1,
			controls : true,
			controlsContainer: carouselNav,
			nav: true,
			slideBy: 1,
			navPosition: 'top',
			touch: true,
			mouseDrag: true,
			responsive : {
				450 : { items : 2, slideBy: 2 },
				860 : { items : 3, slideBy: 3 },
				1150 : { items : 4, slideBy: 4 },
			}
		})
	})
}


